import React from "react";
import { endpoints } from "@/lib/api";

// Renders a check-in's photos: side-by-side before/after when both are present,
// otherwise a single image (either the new single slots or the legacy photo_path).
export default function WinPhotos({ post, size = "md", testId = "" }) {
  const before = post.photo_before_path;
  const after = post.photo_after_path;
  const single = post.photo_path;
  const hasBoth = before && after;
  const height = size === "sm" ? "h-40" : size === "lg" ? "h-72" : "h-56";

  if (!hasBoth && !before && !after && !single) return null;

  if (hasBoth) {
    return (
      <div className="grid grid-cols-2 gap-1 rounded-md overflow-hidden border hairline bg-[hsl(var(--sand))]" data-testid={testId || `photos-split-${post.id}`}>
        <PhotoPane path={before} label="Then" height={height} testid={`before-${post.id}`} />
        <PhotoPane path={after} label="Now" height={height} testid={`after-${post.id}`} />
      </div>
    );
  }

  const path = single || after || before;
  const label = single ? null : after ? "Now" : "Then";
  return (
    <div className="rounded-md overflow-hidden border hairline bg-[hsl(var(--sand))]" data-testid={testId || `photo-${post.id}`}>
      <PhotoPane path={path} label={label} height={height} testid={`single-${post.id}`} />
    </div>
  );
}

function PhotoPane({ path, label, height, testid }) {
  return (
    <div className="relative">
      <img
        src={endpoints.fileUrl(path)}
        alt={label || "check-in"}
        loading="lazy"
        data-testid={testid}
        className={`w-full ${height} object-cover`}
      />
      {label && (
        <span className="absolute top-2 left-2 text-[10px] uppercase tracking-[0.2em] px-2 py-1 rounded-full bg-black/55 text-white backdrop-blur-sm">
          {label}
        </span>
      )}
    </div>
  );
}
